module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_31.de27c4f6.mp3";